import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

import { usePlatformGetPlatform } from "@/api/orval/platform/platform";
import { PlatformLogo } from "@/components/PlatformLogo";
import { ANIMATION_DURATION } from "@/constants/animations.constants";
import { useTranslation } from "@/core/i18n";
import { OnboardingHeader } from "@/modules/onboarding/components/OnboardingScreenHeader/OnboardingHeader";
import { PersonalisationScreenLayout } from "@/modules/personalisation/components/PersonalisationScreenLayout";
import { Button } from "atoms/button/Button";

export const V3ReferralOfferForNewClientsPage_PATH =
  "/signin/referral-offer-for-new-clients" as const;

/** Shown after sign-in to an existing client who opened a friend's referral link: the friend's offer is for new clients. */
const V3ReferralOfferForNewClientsPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { data: platform } = usePlatformGetPlatform();

  return (
    <PersonalisationScreenLayout>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: ANIMATION_DURATION, delay: 0.1 }}
        className="mx-auto flex w-[322px] flex-1 flex-col items-center pt-[50%]"
      >
        <PlatformLogo
          platformName={platform?.name}
          logoUrl={platform?.logoImageUrl}
          className="mb-16"
        />
        <OnboardingHeader
          title={t("v3ReferralOfferForNewClientsPage.title", {
            platformName: platform?.name ?? "",
          })}
          subtitle={t("v3ReferralOfferForNewClientsPage.subtitle")}
          className="mb-8"
          titleClassName="!text-[30px] !leading-8 text-center"
          subtitleClassName="mt-4 text-center"
        />
        <Button fullWidth onClick={() => navigate("/home?fromSignIn=true")}>
          {t("v3ReferralOfferForNewClientsPage.continue")}
        </Button>
      </motion.div>
    </PersonalisationScreenLayout>
  );
};

export default V3ReferralOfferForNewClientsPage;
